var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReorderDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 19.25V7.33333M11 19.25L12.8333 17.4167M11 19.25L9.16667 17.4167M13.75 10.0833H16.9583C18.224 10.0833 19.25 11.1093 19.25 12.375C19.25 13.6407 18.224 14.6667 16.9583 14.6667H13.75M8.25 10.0833H5.04167C3.77601 10.0833 2.75 11.1093 2.75 12.375C2.75 13.6407 3.77601 14.6667 5.04167 14.6667H8.25M16.9583 2.75H5.04167C3.77601 2.75 2.75 3.77601 2.75 5.04167C2.75 6.30732 3.77601 7.33333 5.04167 7.33333H16.9583C18.224 7.33333 19.25 6.30732 19.25 5.04167C19.25 3.77601 18.224 2.75 16.9583 2.75Z",
    stroke: "#7C7C7F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReorderDown);
export default __webpack_public_path__ + "static/media/reorder-down.c5d9b3ff.svg";
export { ForwardRef as ReactComponent };